import { iconList } from "@/lib/get-icon";
import { SERVICES_WE_OFFER_DATA_V2 } from "@/components/sections/services-we-offer";
import { Component } from "@builder.io/sdk";

export const servicesWeOfferConfig: Component = {
  name: "Services We Offer (Home)",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "What We Offer",
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "We provide more than customized care and staffing solutions.",
    },
    {
      name: "services",
      type: "list",
      defaultValue: SERVICES_WE_OFFER_DATA_V2,
      subFields: [
        {
          name: "icon",
          type: "string",
          enum: iconList,
          required: true,
          helperText: "Icon to display for the services we offer",
          defaultValue: "enhanced-quality-of-life",
        },
        {
          name: "title",
          type: "string",
        },
        {
          name: "cta",
          friendlyName: "Main Card Settings",
          type: "object",
          subFields: [
            {
              name: "href",
              type: "string",
              required: true,
            },
            {
              name: "text",
              friendlyName: "Button Text",
              type: "string",
              required: true,
              defaultValue: "Learn More",
            },
            {
              name: "prefetch",
              friendlyName: "Prefetch",
              type: "boolean",
              defaultValue: false,
              advanced: true,
            },
            {
              name: "ariaLabel",
              friendlyName: "Aria Label",
              type: "string",
            },
            {
              name: "className",
              friendlyName: "Class Name",
              type: "string",
              defaultValue:
                "text-body-3-400 font-montserrat font-normal mt-0 px-2 py-1 lg:text-subheading-4-600",
              advanced: true,
            },
            {
              name: "color",
              friendlyName: "Color",
              type: "string",
              enum: ["orange", "teal"],
              defaultValue: "orange",
            },
          ],
        },
        {
          name: "items",
          type: "list",
          subFields: [
            {
              name: "name",
              type: "string",
            },
            {
              name: "href",
              type: "string",
            },
            {
              name: "prefetch",
              type: "boolean",
            },
          ],
        },
      ],
    },
  ],
};
